"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M19.233 4H4.764C3.238 4 2 5.228 2 6.74V20l4.558-2.964h12.678c1.526 0 2.764-1.228 2.764-2.74V6.74C22 5.228 20.762 4 19.233 4zm-4.627 9.386H5.591v-1.482h9.015v1.482zm3.8-4.254H5.591V7.65h12.815v1.482z" }), "Social");
//# sourceMappingURL=Social.js.map